import Controller from '@ember/controller';
import { tracked } from '@glimmer/tracking';
import { action } from '@ember/object';
import { inject as service } from '@ember/service';
import PushService from 'cio/services/push';
import AnalyticsService from 'cio/services/analytics';
import { Platform, PlatformProvider } from 'cio/models/action';

export default class AndroidController extends Controller {
  @service push!: PushService;
  @service analytics!: AnalyticsService;

  isDirty = false;

  @tracked isConfigurationEmpty = false;
  @tracked showDisable = false;
  @tracked isEditing = false;

  get showEmptyState() {
    return this.isConfigurationEmpty && !this.isEditing;
  }

  @action
  startConfiguring() {
    this.isEditing = true;
  }

  @action
  async disableCredential() {
    await this.push.disableCredential.perform('fcm');
    this.showDisable = false;
    this.isConfigurationEmpty = true;
    this.analytics.track('push', 'push_disabled', {
      platform: Platform.Android,
      provider: PlatformProvider.FCM,
    });
  }

  @action
  async afterSave() {
    this.analytics.track('push', !this.isConfigurationEmpty ? 'authorization_updated' : 'authorization_added', {
      platform: Platform.Android,
      provider: PlatformProvider.FCM,
    });
    this.isConfigurationEmpty = false;

    await this.push.loadCredentials.perform();
    let { platforms } = this.push;
    let isAndroidOnlyFCMPlatform = !(
      platforms.length > 1 && platforms.every((platform: any) => platform.provider === 'fcm')
    );
    this.showDisable = isAndroidOnlyFCMPlatform;
  }
}
